import { rants } from "@/mocks/comics";

export default function Rants() {
  return (
    <section id="rants" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-message-3-line"></i> 本周精选
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              神吐槽精选
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              一针见血的吐槽，句句扎心又好笑。看过的朋友纷纷表示：这说的不就是我吗？
            </p>
          </div>
          <a
            href="#memes"
            className="whitespace-nowrap text-sm text-accent-600 hover:text-accent-700"
          >
            去刷梗图段子 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {rants.map((r) => (
            <article
              key={r.id}
              className="group flex flex-col gap-4 overflow-hidden rounded-2xl border border-background-200 bg-background-100/60 p-4 transition-transform duration-300 hover:-translate-y-1 sm:flex-row md:p-5"
            >
              <div className="aspect-[3/4] w-full shrink-0 overflow-hidden rounded-xl sm:w-44">
                <img
                  src={r.image}
                  alt={`韩国歪歪漫画-${r.title}`}
                  title={`${r.title}-神吐槽段子`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col">
                <span className="inline-flex w-fit items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-700">
                  <i className="ri-focus-3-line"></i> 神吐槽
                </span>
                <h3 className="mt-2 font-heading text-base text-foreground-950 md:text-lg">
                  {r.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {r.text}
                </p>
                <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-heart-3-fill text-accent-500"></i> {r.likes.toLocaleString()}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line"></i> {r.replies}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}